import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import { useIsActorSyncPreparing } from "@-/dev.improve.haniverse.routes.nav._context";
import { ActivityIndicator, View } from "@-/com.npmjs.react-native";
import type { ReactNode } from "react";

/**
 * Holds routes backed by the actor database while a signed-in account is opening
 * and pulling its initial data. The gate lives inside each tab scene, leaving the
 * app shell and the data-independent Browse and Search tabs interactive.
 */
export function UserDataLoadingGate({
  children,
  enabled = true,
  fallback,
}: {
  children: ReactNode;
  enabled?: boolean;
  fallback?: ReactNode;
}) {
  const isActorSyncPreparing = useIsActorSyncPreparing();

  if (!enabled || !isActorSyncPreparing) {
    return children;
  }

  if (fallback !== undefined) {
    return fallback;
  }

  return (
    <View
      accessibilityLabel="Loading your learning data"
      className="flex-1 items-center justify-center gap-4 bg-background px-8"
    >
      <ActivityIndicator size="large" />
      <View className="items-center gap-2">
        <Text className="text-center text-sm text-muted-foreground">
          Browse and Search are ready while this finishes.
        </Text>
      </View>
    </View>
  );
}
